<style>
</style>
<template>
    <span>
    <Button @click="showExamOptDrawer" type="warning" size="small">题目</Button>
    <Drawer title="教育经历" :closable="false" placement="right" v-model="drawerVisible">

    </Drawer>
    </span>
</template>
<script>
    import {selectAllMenu, grantMenu} from "@/api/index";

    export default {
        name: "examOptDrawer",
        props: {
            role: Object
        },
        data() {
            return {
                drawerVisible: false
            }
        },
        methods: {

            //加载数据
            showExamOptDrawer() {
                this.drawerVisible = true;
            }
        },
        mounted() {

        }
    }
</script>